import { useQuery } from 'react-query';
import { getFlexDutyHourTypes } from 'RestAPIs/flex-duty-hour-types';

const useGetFlexDutyHourTypes = () => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['flexDutyHourTypes', 'list'],
    async () => {
      const { data } = await getFlexDutyHourTypes();
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetFlexDutyHourTypes;
